import { Delete } from "lucide-react";

// Pavé numérique réutilisable — même disposition et même logique partout
// (Login, "Fixer prix" du Stock...), avec un style personnalisable par appel
// pour s'adapter à l'identité visuelle de chaque écran. Le support du
// clavier physique n'est PAS géré ici : chaque écran appelant a des besoins
// différents (Login doit aussi distinguer un lecteur de badge d'une vraie
// frappe humaine, "Fixer prix" non) — il reste donc à la charge de l'appelant,
// qui relaie simplement vers les mêmes `onDigit`/`onBackspace`/`onDecimal`/`onSubmit`.
//
// Deux dispositions de la dernière ligne, choisies via `showSubmit` :
//   - false (défaut, ex. "Fixer prix") : [ , ]  [ 0 ]  [ backspace ]
//   - true  (ex. Login)               : [ backspace ]  [ 0 ]  [ OK ]
export function NumericKeypad({
  onDigit,
  onBackspace,
  onDecimal,
  onSubmit,
  disabled = false,
  testIdPrefix = "keypad",
  keyClassName,
  showDecimal = false,
  showSubmit = false,
  backspaceSubLabel,
  submitSubLabel,
}) {
  const cls = keyClassName ||
    "min-h-[64px] rounded-xl border border-border bg-secondary hover:border-primary text-xl font-semibold font-mono active:scale-95 transition-transform duration-100 disabled:opacity-50";

  const SubLabel = ({ children }) =>
    children ? (
      <span className="absolute bottom-1.5 right-2 text-[9px] font-normal opacity-60 normal-case tracking-normal">
        {children}
      </span>
    ) : null;

  return (
    <div className="grid grid-cols-3 gap-3">
      {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
        <button
          key={d}
          type="button"
          data-testid={`${testIdPrefix}-button-${d}`}
          onClick={() => onDigit(d)}
          disabled={disabled}
          className={cls}
        >
          {d}
        </button>
      ))}

      {showSubmit ? (
        <button
          type="button"
          data-testid={`${testIdPrefix}-button-backspace`}
          onClick={onBackspace}
          disabled={disabled}
          className={`${cls} relative flex items-center justify-center`}
        >
          <Delete size={20} />
          <SubLabel>{backspaceSubLabel}</SubLabel>
        </button>
      ) : showDecimal ? (
        <button
          type="button"
          data-testid={`${testIdPrefix}-button-decimal`}
          onClick={onDecimal}
          disabled={disabled}
          className={cls}
        >
          ,
        </button>
      ) : (
        <div />
      )}

      <button
        type="button"
        data-testid={`${testIdPrefix}-button-0`}
        onClick={() => onDigit("0")}
        disabled={disabled}
        className={cls}
      >
        0
      </button>

      {showSubmit ? (
        <button
          type="button"
          data-testid={`${testIdPrefix}-button-submit`}
          onClick={onSubmit}
          disabled={disabled}
          className={`${cls} relative`}
        >
          OK
          <SubLabel>{submitSubLabel}</SubLabel>
        </button>
      ) : (
        <button
          type="button"
          data-testid={`${testIdPrefix}-button-backspace`}
          onClick={onBackspace}
          disabled={disabled}
          className={`${cls} flex items-center justify-center`}
        >
          <Delete size={20} />
        </button>
      )}
    </div>
  );
}
